import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CoverpathUtils } from '../../../../coverpath-common/js/static/CoverpathUtils';
import { AmorphicService } from '../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { WindowService } from '../../../../common/angular-shared/services/window/window.service';
import { GenesysContext, GenesysParticipantData } from '../../../../common/js/types/CommonTypes';

@Component({
    selector: 'mm-direct-root',
    templateUrl: './app.component.html'
})
export class AppComponent {

    isAuthenticationPathResolved: boolean = false;
    genesysParticipantData : GenesysParticipantData;

    constructor(private router: Router,
                private amorphicService: AmorphicService,
                private windowService: WindowService) {
        CoverpathUtils.dataLayerPush({
            environment: this.amorphicService.controller.nonProdMode ? 'development' : 'production'
        });
    }

    async ngOnInit(): Promise<void> {
        const controller = this.windowService.nativeWindow.controller;
        
        this.genesysParticipantData = {
          'WP-Authenticated': false,
          'WP-Is-1851': false,
          'WP-Context': GenesysContext.MM_DIRECT
        }

        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            CoverpathUtils.scrollToTop();
        });

        if (controller) {
            await controller.resolveAuth0Data();
            this.isAuthenticationPathResolved = true;
        }
    }
}
